module.exports = __webpack_public_path__ + "img/t3-16.1b85d0f2.png";